export const videos = [
  {
    id: 'v001',
    title: '街头吉他弹唱《晴天》 路人纷纷驻足',
    category: 'music',
    cover: 'https://readdy.ai/api/search-image?query=Young%20musician%20playing%20acoustic%20guitar%20on%20a%20warm%20city%20sidewalk%20at%20dusk%2C%20golden%20streetlight%20glow%2C%20blurred%20pedestrians%20in%20background%2C%20clean%20cinematic%20vertical%20composition%2C%20warm%20red%20and%20amber%20tones%2C%20high%20detail&width=600&height=800&seq=video-music-01&orientation=portrait',
    duration: '01:24',
    likes: 128600,
    comments: 3420,
    shares: 1890,
    plays: 2450000,
    author: '阿泽Music',
    authorTag: '原创',
    publishDate: '2026-09-28',
    tags: ['吉他', '翻唱', '街头音乐'],
    description: '在街角唱了一首《晴天》，本来只是自己练手，没想到围了一圈人一起合唱。音乐真的会让陌生人也变成朋友。',
  },
  {
    id: 'v002',
    title: '深夜钢琴即兴 一段治愈系旋律',
    category: 'music',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20piano%20in%20a%20dim%20warm%20room%20with%20a%20single%20spotlight%2C%20hands%20on%20keys%2C%20moody%20cinematic%20vertical%20shot%2C%20deep%20shadows%20and%20amber%20glow%2C%20editorial%20music%20photography%2C%20high%20detail&width=600&height=800&seq=video-music-02&orientation=portrait',
    duration: '02:10',
    likes: 96300,
    comments: 2180,
    shares: 1420,
    plays: 1780000,
    author: '夜航键客',
    authorTag: '精选',
    publishDate: '2026-09-30',
    tags: ['钢琴', '即兴', '治愈'],
    description: '凌晨两点睡不着，随手弹了一段。没有谱子，全是当下的心情，希望也能让你安静下来。',
  },
  {
    id: 'v003',
    title: '宿舍阿卡贝拉 无伴奏合唱太绝了',
    category: 'music',
    cover: 'https://readdy.ai/api/search-image?query=Group%20of%20college%20students%20singing%20a%20cappella%20in%20a%20warm%20lit%20dorm%20room%2C%20joyful%20energy%2C%20vertical%20composition%2C%20clean%20interior%20background%2C%20warm%20amber%20lighting%2C%20high%20detail&width=600&height=800&seq=video-music-03&orientation=portrait',
    duration: '01:48',
    likes: 74500,
    comments: 1960,
    shares: 980,
    plays: 1120000,
    author: '403宿舍',
    authorTag: '原创',
    publishDate: '2026-09-25',
    tags: ['阿卡贝拉', '合唱', '宿舍'],
    description: '四个人的宿舍，四张嘴就是一个乐队。熄灯前十分钟录的，一条过，我们自己都惊了。',
  },
  {
    id: 'v004',
    title: '电音打碟现场 燃爆全场的十分钟',
    category: 'music',
    cover: 'https://readdy.ai/api/search-image?query=DJ%20performing%20on%20stage%20with%20glowing%20lighting%20and%20crowd%20silhouettes%2C%20dynamic%20motion%2C%20vertical%20concert%20shot%2C%20red%20and%20orange%20stage%20light%2C%20high%20energy%20photography%2C%20high%20detail&width=600&height=800&seq=video-music-04&orientation=portrait',
    duration: '03:05',
    likes: 153200,
    comments: 4620,
    shares: 3210,
    plays: 3120000,
    author: 'DJ_阿屿',
    authorTag: '热门',
    publishDate: '2026-10-02',
    tags: ['电音', '打碟', '现场'],
    description: '这是昨晚最炸的一段，鼓点一进来全场就跳起来了。戴耳机听效果更爽。',
  },
  {
    id: 'v005',
    title: '猫咪拆家现场 主人当场崩溃',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Mischievous%20cat%20sitting%20next%20to%20scattered%20torn%20tissue%20paper%20in%20a%20bright%20warm%20living%20room%2C%20humorous%20vertical%20composition%2C%20clean%20background%2C%20warm%20orange%20lighting%2C%20high%20detail&width=600&height=800&seq=video-comedy-01&orientation=portrait',
    duration: '00:52',
    likes: 214600,
    comments: 8320,
    shares: 5620,
    plays: 4200000,
    author: '猫奴日记',
    authorTag: '热门',
    publishDate: '2026-10-05',
    tags: ['猫咪', '搞笑', '日常'],
    description: '出门两小时，回家一屋子纸屑。它还用那种无辜的眼神看着我，我居然一点脾气都没有了。',
  },
  {
    id: 'v006',
    title: '兄弟整蛊 结果反被套路',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Two%20friends%20laughing%20in%20a%20bright%20colorful%20studio%20during%20a%20prank%2C%20playful%20energetic%20mood%2C%20vertical%20composition%2C%20clean%20simple%20background%2C%20orange%20accents%2C%20high%20detail&width=600&height=800&seq=video-comedy-02&orientation=portrait',
    duration: '01:12',
    likes: 132400,
    comments: 4710,
    shares: 2980,
    plays: 2650000,
    author: '憨憨兄弟',
    authorTag: '精选',
    publishDate: '2026-10-01',
    tags: ['整蛊', '兄弟', '反转'],
    description: '本来想整他，结果人家早就准备好了。兄弟们，整蛊有风险，出手需谨慎。',
  },
  {
    id: 'v007',
    title: '打工人早八的100种崩溃瞬间',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Sleepy%20young%20office%20worker%20rushing%20with%20coffee%20in%20a%20warm%20morning%20city%20scene%2C%20humorous%20vertical%20composition%2C%20clean%20background%2C%20soft%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-comedy-03&orientation=portrait',
    duration: '00:58',
    likes: 187300,
    comments: 6940,
    shares: 4180,
    plays: 3560000,
    author: '摆烂的小周',
    authorTag: '原创',
    publishDate: '2026-09-29',
    tags: ['打工人', '早八', '共鸣'],
    description: '闹钟按掉第五次的时候，我就知道这一天注定不平凡。献给每一个被早八支配的打工人。',
  },
  {
    id: 'v008',
    title: '爸爸带娃 一言难尽的带娃日常',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20young%20father%20playing%20with%20a%20toddler%20in%20a%20bright%20cozy%20living%20room%2C%20chaotic%20joyful%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20soft%20amber%20light%2C%20high%20detail&width=600&height=800&seq=video-comedy-04&orientation=portrait',
    duration: '01:30',
    likes: 158900,
    comments: 5230,
    shares: 3670,
    plays: 2980000,
    author: '奶爸不哭',
    authorTag: '精选',
    publishDate: '2026-09-27',
    tags: ['带娃', '亲子', '搞笑'],
    description: '妈妈出门一天，我把家里带成了灾难现场。娃倒是很开心，就是我的头发少了点。',
  },
  {
    id: 'v009',
    title: '出租屋改造 1000元变身ins风',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20renovated%20small%20rental%20room%20with%20plants%20warm%20linen%20and%20soft%20lighting%2C%20minimal%20interior%2C%20vertical%20composition%2C%20clean%20neutral%20background%2C%20warm%20amber%20tones%2C%20high%20detail&width=600&height=800&seq=video-life-01&orientation=portrait',
    duration: '02:40',
    likes: 176500,
    comments: 6120,
    shares: 4890,
    plays: 3240000,
    author: '小屋研究所',
    authorTag: '原创',
    publishDate: '2026-10-03',
    tags: ['出租屋', '改造', 'ins风'],
    description: '花了一千块，把二十平的小屋改成了想要的样子。清单放评论区了，姐妹们冲！',
  },
  {
    id: 'v010',
    title: '早起5分钟 十分钟搞定快手早餐',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Simple%20bright%20breakfast%20table%20with%20toast%20eggs%20and%20fruit%20in%20warm%20morning%20sunlight%2C%20clean%20minimal%20vertical%20composition%2C%20soft%20neutral%20background%2C%20appetizing%20food%20photography%2C%20high%20detail&width=600&height=800&seq=video-life-02&orientation=portrait',
    duration: '01:35',
    likes: 89400,
    comments: 3210,
    shares: 2140,
    plays: 1560000,
    author: '一顿早餐',
    authorTag: '精选',
    publishDate: '2026-09-26',
    tags: ['早餐', '快手', '食谱'],
    description: '十分钟，三样食材，一份好吃又好看的早餐。再忙也要好好吃早饭呀。',
  },
  {
    id: 'v011',
    title: '阳台小花园 我的治愈角落',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Sunlit%20balcony%20filled%20with%20green%20potted%20plants%20and%20a%20small%20wooden%20chair%2C%20calm%20cozy%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=600&height=800&seq=video-life-03&orientation=portrait',
    duration: '01:52',
    likes: 67800,
    comments: 1980,
    shares: 1230,
    plays: 980000,
    author: '绿手指先生',
    authorTag: '原创',
    publishDate: '2026-09-22',
    tags: ['阳台', '植物', '治愈'],
    description: '两平米的阳台，种满了我的小心情。每天浇水的那几分钟，是一天里最放松的时刻。',
  },
  {
    id: 'v012',
    title: '断舍离挑战 整理房间全记录',
    category: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Neat%20minimal%20room%20with%20folded%20clothes%20and%20storage%20baskets%20in%20soft%20daylight%2C%20organized%20calm%20mood%2C%20vertical%20composition%2C%20clean%20neutral%20background%2C%20high%20detail&width=600&height=800&seq=video-life-04&orientation=portrait',
    duration: '03:20',
    likes: 58300,
    comments: 1670,
    shares: 920,
    plays: 760000,
    author: '整理控Lily',
    authorTag: '精选',
    publishDate: '2026-09-20',
    tags: ['断舍离', '收纳', '整理'],
    description: '狠下心扔掉了一百件东西，房间空了，心也跟着轻了。断舍离真的会上瘾。',
  },
  {
    id: 'v013',
    title: '三分钟学会爆汁小笼包',
    category: 'food',
    cover: 'https://readdy.ai/api/search-image?query=Bamboo%20steamer%20of%20juicy%20soup%20dumplings%20with%20rising%20steam%20on%20a%20warm%20wooden%20table%2C%20appetizing%20close%20up%2C%20vertical%20composition%2C%20clean%20simple%20background%2C%20rich%20warm%20tones%2C%20high%20detail&width=600&height=800&seq=video-food-01&orientation=portrait',
    duration: '03:10',
    likes: 226400,
    comments: 7840,
    shares: 6540,
    plays: 4560000,
    author: '厨房大魔王',
    authorTag: '热门',
    publishDate: '2026-10-04',
    tags: ['小笼包', '教程', '面点'],
    description: '皮薄馅大，一咬爆汁。关键就在那勺皮冻，比例我都写好了，跟着做不会翻车。',
  },
  {
    id: 'v014',
    title: '深夜食堂 一碗销魂牛肉面',
    category: 'food',
    cover: 'https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20beef%20noodles%20with%20fresh%20herbs%20and%20chili%20oil%20on%20a%20dark%20warm%20table%2C%20moody%20appetizing%20close%20up%2C%20vertical%20composition%2C%20clean%20background%2C%20rich%20red%20tones%2C%20high%20detail&width=600&height=800&seq=video-food-02&orientation=portrait',
    duration: '02:25',
    likes: 198700,
    comments: 6520,
    shares: 5120,
    plays: 3820000,
    author: '深夜食客',
    authorTag: '精选',
    publishDate: '2026-10-06',
    tags: ['牛肉面', '夜宵', '面食'],
    description: '熬了四个小时的牛骨汤，配上手打面，撒一把香菜。这一口下去，什么烦恼都没了。',
  },
  {
    id: 'v015',
    title: '空气炸锅万能食谱 懒人必备',
    category: 'food',
    cover: 'https://readdy.ai/api/search-image?query=Crispy%20golden%20roasted%20vegetables%20and%20chicken%20fresh%20from%20an%20air%20fryer%20on%20a%20bright%20kitchen%20counter%2C%20appetizing%20vertical%20composition%2C%20clean%20simple%20background%2C%20warm%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-food-03&orientation=portrait',
    duration: '01:58',
    likes: 143200,
    comments: 4980,
    shares: 3760,
    plays: 2380000,
    author: '懒人厨房',
    authorTag: '原创',
    publishDate: '2026-09-24',
    tags: ['空气炸锅', '懒人', '食谱'],
    description: '自从有了空气炸锅，我做饭的时间缩短了一半。这六道菜谱简单到闭着眼都能做。',
  },
  {
    id: 'v016',
    title: '家庭版麻辣香锅 香到邻居敲门',
    category: 'food',
    cover: 'https://readdy.ai/api/search-image?query=Spicy%20dry%20hot%20pot%20with%20colorful%20vegetables%20and%20meat%20in%20a%20sizzling%20wok%2C%20rich%20red%20chili%20tones%2C%20vertical%20appetizing%20composition%2C%20clean%20warm%20background%2C%20high%20detail&width=600&height=800&seq=video-food-04&orientation=portrait',
    duration: '02:48',
    likes: 167800,
    comments: 5720,
    shares: 4230,
    plays: 2760000,
    author: '川味小厨',
    authorTag: '热门',
    publishDate: '2026-09-23',
    tags: ['麻辣香锅', '川菜', '家常菜'],
    description: '自己配的料，干净又入味，一大锅配两碗米饭根本不够。做完记得开窗通风。',
  },
  {
    id: 'v017',
    title: '街舞battle 全场沸腾的60秒',
    category: 'dance',
    cover: 'https://readdy.ai/api/search-image?query=Street%20dancer%20performing%20a%20powerful%20move%20in%20a%20dark%20studio%20with%20red%20spotlight%2C%20dynamic%20motion%2C%20vertical%20composition%2C%20clean%20moody%20background%2C%20high%20energy%20photography%2C%20high%20detail&width=600&height=800&seq=video-dance-01&orientation=portrait',
    duration: '01:02',
    likes: 189500,
    comments: 5430,
    shares: 4120,
    plays: 2870000,
    author: 'B-Boy小凯',
    authorTag: '热门',
    publishDate: '2026-10-05',
    tags: ['街舞', 'battle', 'Breaking'],
    description: '最后一轮 battle，音乐一响身体就自己动了。这个 freeze 练了整整三个月。',
  },
  {
    id: 'v018',
    title: '古典舞《洛神》 水袖翻飞太美了',
    category: 'dance',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20Chinese%20dancer%20with%20flowing%20silk%20sleeves%20in%20soft%20stage%20light%2C%20graceful%20poetic%20mood%2C%20vertical%20composition%2C%20clean%20dark%20warm%20background%2C%20high%20detail&width=600&height=800&seq=video-dance-02&orientation=portrait',
    duration: '02:35',
    likes: 214800,
    comments: 6890,
    shares: 5340,
    plays: 3680000,
    author: '水袖姑娘',
    authorTag: '精选',
    publishDate: '2026-10-01',
    tags: ['古典舞', '国风', '水袖'],
    description: '排练了半年，终于把这段《洛神》完整跳下来。水袖甩出去的那一瞬间，我好像真的飞起来了。',
  },
  {
    id: 'v019',
    title: '校园随机舞蹈 一整个操场都跳起来了',
    category: 'dance',
    cover: 'https://readdy.ai/api/search-image?query=Crowd%20of%20students%20dancing%20together%20on%20a%20sunny%20university%20field%2C%20joyful%20energetic%20mood%2C%20vertical%20composition%2C%20clean%20open%20background%2C%20warm%20daylight%2C%20high%20detail&width=600&height=800&seq=video-dance-03&orientation=portrait',
    duration: '03:40',
    likes: 96200,
    comments: 2870,
    shares: 1980,
    plays: 1340000,
    author: '操场气氛组',
    authorTag: '原创',
    publishDate: '2026-09-28',
    tags: ['随机舞蹈', '校园', 'Kpop'],
    description: '音乐一放，谁都可以上来跳一段。青春就是这样，随时都能燃起来。',
  },
  {
    id: 'v020',
    title: 'K-pop翻跳 一镜到底挑战',
    category: 'dance',
    cover: 'https://readdy.ai/api/search-image?query=Group%20of%20dancers%20performing%20a%20synced%20K-pop%20routine%20in%20a%20bright%20studio%20with%20colorful%20lights%2C%20energetic%20vertical%20composition%2C%20clean%20background%2C%20vivid%20red%20accents%2C%20high%20detail&width=600&height=800&seq=video-dance-04&orientation=portrait',
    duration: '03:12',
    likes: 127600,
    comments: 4120,
    shares: 2760,
    plays: 1920000,
    author: 'DanceUnit_778',
    authorTag: '精选',
    publishDate: '2026-09-25',
    tags: ['Kpop', '翻跳', '编舞'],
    description: '一次过，没有剪辑。练了一个月，只为了这三分十二秒的整齐。喜欢就点个赞吧。',
  },
  {
    id: 'v021',
    title: '川西小众路线 雪山湖泊一个人看',
    category: 'travel',
    cover: 'https://readdy.ai/api/search-image?query=Serene%20snow%20mountain%20reflected%20in%20a%20still%20turquoise%20lake%20at%20golden%20hour%2C%20vast%20minimal%20landscape%2C%20vertical%20composition%2C%20clean%20open%20sky%2C%20warm%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-travel-01&orientation=portrait',
    duration: '04:05',
    likes: 173400,
    comments: 4980,
    shares: 5120,
    plays: 2650000,
    author: '行走的阿拓',
    authorTag: '精选',
    publishDate: '2026-10-02',
    tags: ['川西', '小众', '自驾'],
    description: '开了一天山路，翻过垭口的那一刻，整片湖和雪山都是我的。附上详细路书，收藏慢慢看。',
  },
  {
    id: 'v022',
    title: '一个人去大理 慢生活的七天',
    category: 'travel',
    cover: 'https://readdy.ai/api/search-image?query=Peaceful%20lakeside%20old%20town%20at%20sunset%20with%20traditional%20roofs%20and%20distant%20mountains%2C%20calm%20travel%20mood%2C%20vertical%20composition%2C%20clean%20warm%20sky%2C%20high%20detail&width=600&height=800&seq=video-travel-02&orientation=portrait',
    duration: '05:20',
    likes: 142800,
    comments: 4210,
    shares: 3680,
    plays: 2140000,
    author: '一个人的旅行',
    authorTag: '原创',
    publishDate: '2026-09-29',
    tags: ['大理', '慢生活', 'vlog'],
    description: '一个人也可以很好。看海、发呆、晒太阳，七天时间把自己还给自己。',
  },
  {
    id: 'v023',
    title: '重庆8D魔幻城市 暴走两万步',
    category: 'travel',
    cover: 'https://readdy.ai/api/search-image?query=Neon%20lit%20hilly%20city%20street%20at%20night%20with%20layered%20bridges%20and%20warm%20lights%2C%20vibrant%20urban%20mood%2C%20vertical%20composition%2C%20clean%20dark%20background%2C%20high%20detail&width=600&height=800&seq=video-travel-03&orientation=portrait',
    duration: '03:35',
    likes: 118900,
    comments: 3760,
    shares: 2540,
    plays: 1680000,
    author: '暴走地图',
    authorTag: '热门',
    publishDate: '2026-09-21',
    tags: ['重庆', '城市', '夜景'],
    description: '导航在重庆完全失灵，一楼是二十楼，走两步就迷路。但夜景真的太绝了，值。',
  },
  {
    id: 'v024',
    title: '海岛浮潜 海底世界美到失语',
    category: 'travel',
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20coral%20reef%20with%20colorful%20tropical%20fish%20in%20clear%20blue%20water%2C%20bright%20travel%20mood%2C%20vertical%20composition%2C%20clean%20sunlit%20background%2C%20high%20detail&width=600&height=800&seq=video-travel-04&orientation=portrait',
    duration: '02:58',
    likes: 105600,
    comments: 3120,
    shares: 2210,
    plays: 1420000,
    author: '潜水的小鱼',
    authorTag: '精选',
    publishDate: '2026-09-19',
    tags: ['浮潜', '海岛', '海底'],
    description: '第一次浮潜，看到成群的小鱼从身边游过，整个人都呆住了。海真的会治愈人。',
  },
  {
    id: 'v025',
    title: '金毛第一次看海 兴奋到原地转圈',
    category: 'pets',
    cover: 'https://readdy.ai/api/search-image?query=Happy%20golden%20retriever%20running%20on%20a%20sunny%20beach%20with%20waves%20behind%2C%20joyful%20warm%20mood%2C%20vertical%20composition%2C%20clean%20bright%20background%2C%20soft%20golden%20light%2C%20high%20detail&width=600&height=800&seq=video-pets-01&orientation=portrait',
    duration: '01:18',
    likes: 247100,
    comments: 8340,
    shares: 6120,
    plays: 4120000,
    author: '金毛豆豆',
    authorTag: '热门',
    publishDate: '2026-10-06',
    tags: ['金毛', '看海', '治愈'],
    description: '带豆豆第一次来海边，它愣了三秒，然后撒腿就跑。那一刻它笑得比谁都开心。',
  },
  {
    id: 'v026',
    title: '布偶猫的睡姿合集 一秒睡着不是传说',
    category: 'pets',
    cover: 'https://readdy.ai/api/search-image?query=Fluffy%20ragdoll%20cat%20sleeping%20curled%20up%20on%20a%20soft%20cream%20blanket%2C%20adorable%20cozy%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=600&height=800&seq=video-pets-02&orientation=portrait',
    duration: '01:44',
    likes: 183500,
    comments: 5620,
    shares: 3980,
    plays: 2680000,
    author: '布偶小公主',
    authorTag: '精选',
    publishDate: '2026-10-03',
    tags: ['布偶猫', '睡姿', '萌宠'],
    description: '我家猫随时随地都能睡着，姿势还一个比一个离谱。看到最后一张我笑出声了。',
  },
  {
    id: 'v027',
    title: '仓鼠囤粮 腮帮子鼓鼓的像个小仓库',
    category: 'pets',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20hamster%20stuffing%20its%20cheeks%20with%20seeds%20in%20a%20cozy%20cage%2C%20adorable%20funny%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20soft%20lighting%2C%20high%20detail&width=600&height=800&seq=video-pets-03&orientation=portrait',
    duration: '00:48',
    likes: 156700,
    comments: 4870,
    shares: 3120,
    plays: 2180000,
    author: '仓鼠日常',
    authorTag: '原创',
    publishDate: '2026-09-27',
    tags: ['仓鼠', '囤粮', '可爱'],
    description: '给它一颗瓜子，它塞进腮帮子；再给一颗，继续塞。最后鼓得像个小气球，太可爱了。',
  },
  {
    id: 'v028',
    title: '狗狗上班第一天 比我还认真',
    category: 'pets',
    cover: 'https://readdy.ai/api/search-image?query=Adorable%20small%20dog%20wearing%20a%20tiny%20collar%20sitting%20at%20a%20desk%20in%20a%20bright%20office%2C%20funny%20cute%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20high%20detail&width=600&height=800&seq=video-pets-04&orientation=portrait',
    duration: '01:26',
    likes: 169800,
    comments: 5430,
    shares: 3560,
    plays: 2340000,
    author: '带狗上班',
    authorTag: '热门',
    publishDate: '2026-09-22',
    tags: ['狗狗', '上班', '搞笑'],
    description: '今天带它来公司，它一本正经地趴在工位上，比同事都敬业。以后它就是我们的吉祥物了。',
  },
  {
    id: 'v029',
    title: '篮球绝杀 三分压哨全场炸了',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Basketball%20player%20shooting%20a%20buzzer%20beater%20three%20pointer%20on%20an%20outdoor%20court%20at%20sunset%2C%20dramatic%20action%20mood%2C%20vertical%20composition%2C%20clean%20warm%20background%2C%20orange%20sky%2C%20high%20detail&width=600&height=800&seq=video-sports-01&orientation=portrait',
    duration: '00:56',
    likes: 201400,
    comments: 6230,
    shares: 4980,
    plays: 3260000,
    author: '球场老李',
    authorTag: '热门',
    publishDate: '2026-10-04',
    tags: ['篮球', '绝杀', '三分'],
    description: '最后三秒，接球、起跳、出手。球进的那一刻，全场都跳起来了。这辈子最难忘的一球。',
  },
  {
    id: 'v030',
    title: '晨跑打卡 城市醒来的样子',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Runner%20jogging%20on%20an%20empty%20city%20street%20at%20sunrise%20with%20soft%20mist%2C%20calm%20energizing%20mood%2C%20vertical%20composition%2C%20clean%20open%20background%2C%20warm%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-sports-02&orientation=portrait',
    duration: '02:12',
    likes: 78600,
    comments: 2340,
    shares: 1560,
    plays: 980000,
    author: '六点半起床',
    authorTag: '原创',
    publishDate: '2026-09-30',
    tags: ['晨跑', '打卡', '自律'],
    description: '坚持晨跑第100天。清晨的城市特别安静，跑完看着日出，一整天都充满电。',
  },
  {
    id: 'v031',
    title: '徒手健身30天 身体的变化太惊人了',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Fit%20young%20man%20doing%20pushups%20in%20a%20warm%20sunlit%20home%20gym%2C%20motivating%20mood%2C%20vertical%20composition%2C%20clean%20minimal%20background%2C%20warm%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-sports-03&orientation=portrait',
    duration: '03:28',
    likes: 134200,
    comments: 4560,
    shares: 3240,
    plays: 1980000,
    author: '徒手也行',
    authorTag: '精选',
    publishDate: '2026-09-26',
    tags: ['健身', '徒手', '30天'],
    description: '没有器械，没有健身房，就在家练了30天。前后对比放在最后，真的会有变化。',
  },
  {
    id: 'v032',
    title: '滑板新手 摔了100次终于站住了',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Skateboarder%20riding%20at%20an%20outdoor%20skate%20park%20during%20golden%20hour%2C%20dynamic%20youthful%20mood%2C%20vertical%20composition%2C%20clean%20urban%20background%2C%20warm%20orange%20light%2C%20high%20detail&width=600&height=800&seq=video-sports-04&orientation=portrait',
    duration: '02:06',
    likes: 92300,
    comments: 2980,
    shares: 1870,
    plays: 1260000,
    author: '滑板菜鸟',
    authorTag: '原创',
    publishDate: '2026-09-24',
    tags: ['滑板', '新手', '成长'],
    description: '从站都站不稳，到现在能滑个小坡。摔了一百次，但每次爬起来都离成功近一点。',
  },
];